


































import { Component, Vue, PropSync } from 'vue-property-decorator'

@Component
export default class FeatureEditor extends Vue {
  @PropSync('features', { type: Array, default: () => ['GROTHMNT', 'NOTIFICA'] })
  private checkedFeatures!: Array<string>
  private featureData: Array<any> = [
    {
      slots: {
        title: 'moment',
      },
      disabled: true,
      key: 'GROTHMNT',
      children: [
        {
          slots: {
            title: 'comment',
          },
          key: 'COMMENT',
        },
        {
          slots: {
            title: 'parentMoment',
          },
          key: 'PUBGRMNT',
        },
      ],
    },
    {
      slots: {
        title: 'assessment',
      },
      key: 'ASSESSMT',
      children: [
        {
          slots: {
            title: 'assessmentSheet',
          },
          key: 'ASSSHEET',
        },
        {
          slots: {
            title: 'assessmentReport',
          },
          key: 'ASSREPOT',
        },
      ],
    },
    {
      slots: {
        title: 'application',
      },
      key: 'APPLIICA',
      children: [
        {
          slots: {
            title: 'attendance',
          },
          key: 'ATNDANCE',
        },
        {
          slots: {
            title: 'dailyCare',
          },
          key: 'RECORD',
        },
        {
          slots: {
            title: 'diary',
          },
          key: 'DIARY',
        },
        {
          slots: {
            title: 'sketch',
          },
          key: 'PALETTE',
        },
        {
          slots: {
            title: 'recipe',
          },
          key: 'RECIPE',
        },
        {
          slots: {
            title: 'album',
          },
          key: 'ALBUM',
        },
        {
          slots: {
            title: 'calendar',
          },
          key: 'CALENDER',
        },
        {
          slots: {
            title: 'leaveAudit',
          },
          key: 'LEAVE',
        },
        {
          slots: {
            title: 'mibp',
          },
          key: 'MULTIIBP',
        },
        {
          slots: {
            title: 'learningJournal',
          },
          key: 'LEARNJOUR',
        },
        {
          slots: {
            title: 'phdCourse',
          },
          key: 'PHDCOURSE',
        },
      ],
    },
    {
      slots: {
        title: 'message',
      },
      disabled: true,
      key: 'NOTIFICA',
      children: [
        {
          slots: {
            title: 'sendMessage',
          },
          key: 'SENDMESSAGE',
        },
        {
          slots: {
            title: 'replyMessage',
          },
          key: 'REPLYMESSAGE',
        },
      ],
    },
  ]

  private checkFeature(keys, e) {
    const checkedKey = e.node.dataRef.key
    const checked = e.checked
    if (checkedKey === 'GROTHMNT') {
      if (!checked) {
        const newKeys = keys.filter(
          key =>
            key !== 'ASSESSMT' &&
            key !== 'ASSSHEET' &&
            key !== 'ASSREPOT' &&
            key !== 'COMMENT' &&
            key !== 'PCOMMENT'
        )
        this.checkedFeatures = newKeys
      } else {
        this.checkedFeatures = keys
      }
    } else if (checkedKey === 'COMMENT' || checkedKey === 'ASSESSMT' || checkedKey === 'PCOMMENT') {
      if (checked) {
        const newKeys = keys.concat(['GROTHMNT'])
        this.checkedFeatures = newKeys
      } else {
        this.checkedFeatures = keys
      }
    } else if (checkedKey === 'ASSSHEET') {
      if (checked) {
        const newKeys = keys.concat(['GROTHMNT'])
        this.checkedFeatures = newKeys
      } else {
        const newKeys = keys.filter(key => key !== 'ASSESSMT' && key !== 'ASSREPOT')
        this.checkedFeatures = newKeys
      }
    } else if (checkedKey === 'ASSREPOT') {
      if (checked) {
        const newKeys = keys.concat(['GROTHMNT', 'ASSSHEET'])
        this.checkedFeatures = newKeys
      } else {
        this.checkedFeatures = keys
      }
    } else {
      this.checkedFeatures = keys
    }
  }
}
